import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "components/common/loader";
import CustomModal from "components/common/modal";
import TableWrapper from "components/common/table-wrapper";
import RadioButton from "components/common/radio-button/RadioButton";
import AddTaskForm from "./AddTaskForm";
import moment from "moment";
import Tooltip from "components/common/tooltip";
import { addressSection, formatString, getUserInfo } from "utils/common";
// API imports
import { createMember, getMember, updateMember } from "containers/members/api";
import {
  createSurveyComment,
  discardSurvey,
  getSurveyComments,
  getSurveyHistory,
  updateSurveyComment,
  addTask,
  updateTask,
  getActiveUsers,
} from "containers/survey/api";
import Addmemberform from "../members/Addmemberform";
// Icons and Assets
import {
  ArrowLeft,
  Pencil,
  Plus,
  User,
  CaretRight,
  CaretDown,
  Eye,
  FileText,
  Trash,
  DownloadSimple,
} from "phosphor-react";
import OutreachStafIcon from "assets/images/outreach-staf-icon.svg";

// Utils and Constants
import { initialMetaForTable, programTypes } from "constants/common";
import { capitalizeName } from "utils/common";
import AsyncSelect from "components/common/select/AsyncSelect";
import { getSpas } from "containers/spa/api";

// Styles
import "./survey.scss";
import { useDebouncedTemplateDataCallback } from "utils/debouncedHelper";
import { getTemplates } from "containers/templates/api";
import Input from "components/common/input";
import CopyLink from "components/common/copy-link/CopyLink";
export const HeaderCard = ({ icon, title, subTitle }) => {
  return (
    <div className="d-flex align-items-center header-card">
      {icon ? <div className="icon">{icon}</div> : null}
      <div className="d-flex flex-column justify-content-between flex-grow-1 flex-basis-0">
        <span className="heading-xs title text-nowrap">{title}</span>
        <span
          className="heading-smb sub-title"
          style={{ whiteSpace: "normal", wordBreak: "break-word" }}
        >
          {subTitle}
        </span>
      </div>
    </div>
  );
};

const memberInfoTransform = (member = {}) => {
  let full_address = [
    member?.city?.name || "",
    member?.state?.name || "",
    member?.zip_code?.code || "",
  ];
  full_address = full_address
    .filter((segment) => !!segment)
    .join(full_address.length > 1 ? ", " : "");

  return {
    // Existing values
    memberID: member?.id,
    memberAccountNo: member?.account_number,
    memberName: member?.name,
    email: member?.email,
    memberpreferred_spoken_lang:
      member?.member_preferred_language_spoken || "N/A",
    medical_record_number: member?.medical_record_number || "N/A",
    cin: member?.cin || "",
    enrollment_status: member?.enrollment_status || "",
    mif: member?.mif || "",
    mif_status: member?.mif_status || "",
    date_of_birth: member?.date_of_birth,
    city: member?.city || "",
    created_at: member?.created_at || "",
    updated_at: member?.updated_at || "",
    checked: member?.checked || "",
    zip_code: member?.zip_code?.code || "",
    county: member?.county?.name ? `(${member?.county?.name} County)` : "",
    state: member?.state,
    outreach_staff: member?.outreach_staff?.name || "N/A",
    health_plan: member?.health_plan?.name || "N/A",
    conditions: member?.conditions,
    population_focuses: member?.population_focus,
    street: member?.street || "",
    full_address,

    // New values
    preferred_spoken_lang: member?.preferred_spoken_lang || "N/A",
    preferred_written_lang: member?.preferred_written_lang || "N/A",
    homeAddress: member?.home_address || "",
    // homeCity: member.homeCity || "",
    // homeState: member.homeState || "",
    // homeZip: member.homeZip || "",
    mailingAddress: member?.mailing_address || "",
    // mailingCity: member.mailingCity || "",
    // mailingState: member.mailingState || "",
    // mailingZip: member.mailingZip || "",
    gender: member?.gender || "N/A",
    ehtnicity: member?.ehtnicity || "N/A",
    martial_status: member?.martial_status || "N/A",
    aica_account: member?.aica_account || "",
    if_number: member?.if_number || "",
    current_living_situation: member?.current_living_situation || "",
    // subscriber_id: member?.subscriber_id || "",
    phone: member?.phone_number || "",
    email: member?.email || "",
    otherCommunicationPref: member?.otherCommunicationPref || "N/A",
    referrals: member?.referrals,
    approved_referrals: member?.approved_referrals,
    tasks: member?.tasks || [],
    authorizations: member?.authorizations || {},
    //Authorizations information
    auth_number: member?.auth_number || "",
    start_date: member?.start_date,
    end_date: member?.end_date,
    approved_days: member?.approved_days || "",
    auth_program: member?.auth_program || "",
  };
};

const SurveyHistory = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [memberInfo, setMemberInfo] = useState(memberInfoTransform({}));
  const [originalMemberData, setOriginalMemberData] = useState(null);
  const [meta, setMeta] = useState({
    ...initialMetaForTable,
    id: id,
  });
  const [activeTab, setActiveTab] = useState("memberInfo");
  const [showDetailsId, setshowDetailsId] = useState("");
  const [currentTaskEdit, setCurrentTaskEdit] = useState("");
  const [loading, setLoading] = useState(true);
  const [surveyList, setSurveyList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [activeUsers, setActiveUsers] = useState([]);
  const [showMemberInfo, setShowMemberInfo] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showTaskModal, setShowTaskModal] = useState(false);
  const [showCompletedTaskModal, setShowCompletedTaskModal] = useState(false);
  const [selected, setSelected] = useState("");
  const [comment, setComment] = useState("");
  const [templatesList, setTemplatesList] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isTemplateModalVisible, setIsTemplateModalVisible] = useState(false);
  const [selectedMember, setSelectedMember] = useState("");
  const [ismemberModalVisible, setmemberIsModalVisible] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [spaNumbers, setSpaNumbers] = useState([]);
  const [spaNumber, setSpaNumber] = useState("");
  const [spaError, setSpaError] = useState("");

  // Fetch SPA Numbers table on mount
  useEffect(() => {
    const fetchSpaNumbers = async () => {
      try {
        const res = await getSpas({ perPage: 1000 }); // get all
        setSpaNumbers(res?.data || []);
      } catch (e) {
        setSpaNumbers([]);
      }
    };
    fetchSpaNumbers();
  }, []);

  // Determine SPA Number logic
  useEffect(() => {
    if (!memberInfo || !memberInfo.zip_code) {
      setSpaNumber("");
      setSpaError("");
      return;
    }
    // Only for Los Angeles County
    if (
      memberInfo.county &&
      memberInfo.county.toLowerCase().includes("los angeles")
    ) {
      const found = spaNumbers.find(
        (spa) => spa.zip_code === memberInfo.zip_code
      );
      if (found) {
        setSpaNumber(found.spa_number);
        setSpaError("");
      } else {
        setSpaNumber("");
        setSpaError("No SPA Number Found");
      }
    } else {
      setSpaNumber("N/A");
      setSpaError("");
    }
  }, [memberInfo, spaNumbers]);

  const handleOpenTemplateModal = () => {
    setIsTemplateModalVisible(true);
  };
  const handleCloseTemplateModal = () => {
    setIsTemplateModalVisible(false);
    setSelectedTemplate(null);
  };
  const fetchActiveUsers = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getActiveUsers();
      if (result["users"]) {
        setActiveUsers(result.users);
      }
    } catch (error) {
      console.error("Error fetching Users:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  const fetchSurveyHistory = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getSurveyHistory(meta);
      if (result["survey_responses"]) {
        setSurveyList(result.survey_responses);
      }
      setTotalCount(result?.meta.total_count);
    } catch (error) {
      console.error("Error fetching survey history:", error);
    } finally {
      setLoading(false);
    }
  }, [meta]);

  const fetchMember = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getMember(id);
      if (result["member"]) {
        setMemberInfo(memberInfoTransform(result.member));
        setOriginalMemberData(result.member);
        await fetchSurveyComment(result.member.id);
      }
    } catch (error) {
      console.error("Error fetching member:", error);
    } finally {
      setLoading(false);
    }
  }, [id]);

  const fetchSurveyComment = async (memberId) => {
    try {
      const result = await getSurveyComments(memberId);
      if (result?.comments) {
        setComment(result.comments[0]);
      }
    } catch (error) {
      console.error("Error fetching survey comments:", error);
    }
  };

  // Comment handlers
  const handleCommentChange = (event) => {
    setComment((prev) => ({
      ...prev,
      content: event.target.value,
    }));
  };

  const handleCommentUpdationOrCreation = async (event) => {
    const content = event.target.value;
    try {
      const result =
        !comment?.id && memberInfo
          ? await createSurveyComment(memberInfo.memberID, content)
          : await updateSurveyComment(comment?.id, content);

      if (result?.comment) {
        setComment(result.comment);
      }
    } catch (error) {
      console.error("Error updating/creating comment:", error);
    }
  };

  const handlePageChange = (value) => {
    setMeta((pre) => ({ ...pre, page: value }));
  };

  useEffect(() => {
    fetchSurveyHistory();
    fetchMember();
    fetchActiveUsers();
  }, [fetchSurveyHistory, fetchMember, fetchActiveUsers]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Modal handlers
  const handleOpenDeleteModal = (id) => {
    setSelected(id);
    setShowDeleteConfirm(true);
  };

  const handleCloseDeleteModal = () => {
    setSelected("");
    setShowDeleteConfirm(false);
  };

  const handleCloseTaskModal = () => {
    setShowTaskModal(false);
    setCurrentTaskEdit(null);
  };

  const handleCloseCompletedTaskModal = () => {
    setShowCompletedTaskModal(false);
  };

  const handleClosememberModal = () => {
    setmemberIsModalVisible(false);
    setSelectedMember("");
  };
  const handleOpenmemberModal = () => {
    setmemberIsModalVisible(true);
  };
  const handleRefreshPage = () => {
    setRefreshPage((pre) => !pre);
  };
  useEffect(() => {
    fetchSurveyHistory();
    fetchMember();
    fetchActiveUsers();
  }, [fetchSurveyHistory, fetchMember, fetchActiveUsers, refreshPage]);

  const handlememberSubmission = async (member, setErrors) => {
    try {
      let result = "";
      if (selectedMember) {
        result = await updateMember(member, selectedMember.id, setErrors);
      } else {
        result = await createMember(member, setErrors);
      }
      if (result) {
        handleClosememberModal();
        handleRefreshPage();
        await fetchMember();
      }
    } catch (error) {
      console.log("error is ", error);
    }
  };

  // Task handlers
  const handleTaskSubmission = async (task, setSubmitting) => {
    const isEditMode = Boolean(currentTaskEdit);
    try {
      const payload = {
        ...task,
        // user_id: getUserInfo()?.id,
        member_id: memberInfo.memberID,
        status: "open",
      };
      let result;
      if (isEditMode) {
        const currentTaskID = currentTaskEdit.id;
        result = await updateTask(currentTaskID, payload);
      } else {
        result = await addTask(payload);
      }

      if (result) {
        handleCloseTaskModal();
        fetchMember();
      }
    } catch (error) {
      console.error("Error submitting task:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleTaskStatus = async (task) => {
    try {
      const payload = {
        ...task,
        user_id: memberInfo?.tasks?.user?.name,
        member_id: memberInfo.memberID,
        status: "complete",
      };
      let result;
      const currentTaskID = task.id;
      result = await updateTask(currentTaskID, payload);

      if (result) {
        fetchMember();
      }
    } catch (error) {
      console.error("Error submitting task:", error);
    }
  };

  // Survey handlers
  const handleDiscard = async (surveyId) => {
    try {
      await discardSurvey(surveyId);
      setSurveyList((prevList) => {
        const updatedList = prevList.filter((survey) => survey.id !== surveyId);
        return updatedList;
      });
    } catch (error) {
      console.error("Error discarding survey:", error);
    }
  };

  const handleContinue = (surveyId) => {
    const surveyExists = surveyList.some((survey) => survey.id === surveyId);
    navigate(surveyExists ? `/survey/${memberInfo.memberID}` : "/");
  };

  const handleDeleteConfirm = () => {
    handleDiscard(selected);
    handleCloseDeleteModal();
  };
  const toggleMemberInfo = () => {
    if (screenWidth <= 600) {
      setShowMemberInfo((prevState) => !prevState);
    }
  };
  const authFields = [
    { title: "Auth. No.", key: "auth_number" },
    { title: "Approved Days", key: "approved_days" },
    { title: "Start Date", key: "start_date" },
    { title: "End Date", key: "end_date" },
  ];

  const fetchTemplates = useCallback(async () => {
    try {
      const result = await getTemplates(initialMetaForTable);
      if (result["templates"]) {
        const data = result?.templates.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        setTemplatesList(data);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  const debouncedTemplateCallback = useDebouncedTemplateDataCallback();

  useEffect(() => {
    fetchTemplates();
  }, []);
  console.log("memberInfo", originalMemberData);
  return (
    <>
      <div className="row ms-4">
        <div className="col">
          {loading ? (
            <div className="loader-wrapper">
              <Loader />
            </div>
          ) : (
            <>
              <div className="row">
                <div className="col-12 col-sm-9 pe-sm-5">
                  <div className="main-header pb-0">
                    <div className="arrow-and-content">
                      <ArrowLeft
                        className="opacity-50 mb-2 me-2 cursor-pointer"
                        size={24}
                        onClick={() => navigate(-1)}
                      />
                      <h3 className="space">
                        {capitalizeName(memberInfo.memberName)}
                        's History
                      </h3>
                    </div>
                    {/* <button
                      className={`survey-btn secondary-btn cursor-pointer `}
                      onClick={() => {
                        navigate(`/survey/${memberInfo.memberID}`, {
                          state: memberInfo,
                        });
                      }}
                    >
                      Start Survey
                    </button> */}
                  </div>
                </div>
              </div>
              <p className="heading-h4 d-block d-xl-none">Survey History</p>
              <div className="row">
                <div className="col-12 col-md-7 survey-table-wrapper">
                  <TableWrapper
                    isLoading={loading}
                    searchFeild={false}
                    pageSize={meta.perPage}
                    totalListCount={totalCount}
                    onPageChange={handlePageChange}
                    currentPage={meta.page}
                    actionButtons={[
                      {
                        label: "Start Survey",
                        classes: "secondary-btn",
                        handleClick: () => {
                          if (
                            surveyList.some(
                              (survey) => survey.status === "in_progress"
                            )
                          ) {
                            navigate(`/survey/${memberInfo.memberID}`, {
                              state: memberInfo,
                            });
                          } else handleOpenTemplateModal(true);
                        },
                      },
                    ]}
                  >
                    <div
                      className="d-none d-xl-block"
                      style={{
                        position: "absolute",
                        top: "-52px",
                        left: "20px",
                      }}
                    >
                      <span className="heading-h5">Survey History</span>
                    </div>
                    <div className="container-fluid ">
                      <div className="overflow-scroll boarder-radius-20px scrollable">
                        <table className="table table-rows ">
                          <thead className="table-header ">
                            <tr>
                              <th>
                                <div className="form-check p-0 mb-0"></div>
                              </th>
                              <th>Submission Date</th>
                              <th>Submitted by</th>
                              <th>ECM Outcome</th>
                              <th>Template</th>
                              <th>Survey Status</th>
                              <th></th>
                            </tr>
                          </thead>

                          <tbody className="table-body">
                            {surveyList?.map((survey, surveyIndex, arr) => {
                              const showQuestions =
                                surveyIndex === showDetailsId;
                              const isPendingOrInProgress =
                                survey.status === "pending" ||
                                survey.status === "in_progress";
                              return (
                                <>
                                  <tr key={surveyIndex}>
                                    <td>
                                      <div
                                        className={`d-flex justify-content-between align-items-center ms-3 me-3 ${
                                          showQuestions ? "active" : ""
                                        }`}
                                        onClick={() => {
                                          if (showQuestions) {
                                            setshowDetailsId("");
                                          } else {
                                            setshowDetailsId(surveyIndex);
                                          }
                                        }}
                                      >
                                        {showQuestions ? (
                                          <div className="cursor-pointer">
                                            <CaretDown size={20} />
                                          </div>
                                        ) : (
                                          <div className="cursor-pointer">
                                            <CaretRight size={20} />
                                          </div>
                                        )}
                                      </div>
                                    </td>

                                    <td className="fw-bold  ">
                                      {survey.created_at}
                                    </td>
                                    <td className=" ">
                                      {capitalizeName(
                                        survey?.submitted_by_jsonb?.name
                                      ) || "N/A"}
                                    </td>
                                    <td>
                                      {capitalizeName(survey?.ecm_status) ||
                                        "N/A"}
                                    </td>

                                    <td className="fw-bold  ">
                                      {survey.template?.name}
                                    </td>
                                    <td className=" ">
                                      <div
                                        className={`status ${
                                          survey.status === "completed"
                                            ? "Completed"
                                            : survey.status === "in_progress"
                                            ? "inProgress"
                                            : "pending"
                                        } ps-1 pe-1`}
                                      >
                                        {survey.status === "completed"
                                          ? "Completed"
                                          : survey.status === "in_progress"
                                          ? "In Progress"
                                          : "Pending"}
                                      </div>
                                    </td>
                                    <td>
                                      {survey.status !== "completed" && (
                                        <Tooltip title={"Delete"}>
                                          <Trash
                                            size={24}
                                            className="ms-3 opacity-50"
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              handleOpenDeleteModal(survey.id);
                                            }}
                                          />
                                        </Tooltip>
                                      )}
                                    </td>
                                  </tr>
                                  {showQuestions ? (
                                    <tr>
                                      <td
                                        className={`card-footer ${
                                          showQuestions ? "active" : ""
                                        }`}
                                        colSpan={5}
                                      >
                                        <div
                                        // onClick={() => {
                                        //   if (showQuestions) {
                                        //     setshowDetailsId("");
                                        //   } else {
                                        //     setshowDetailsId(surveyIndex);
                                        //   }
                                        // }}
                                        // className="cursor-pointer"
                                        >
                                          {showQuestions &&
                                            survey?.answers_jsonb
                                              ?.filter(
                                                (ans) =>
                                                  ans.selected_answer_options
                                                    ?.length
                                              )
                                              .map((ans, index, arr) => (
                                                <div className="d-flex flex-column ps-4 pt-3 m-3 expand-card">
                                                  <p className="opacity-50">{`Question No.${index +
                                                    1} of ${arr.length}`}</p>
                                                  <h6>{ans?.question_text}</h6>
                                                  {ans?.selected_answer_options?.map(
                                                    (option) => (
                                                      <p
                                                        className="opacity-50"
                                                        style={{
                                                          maxWidth: "600px",
                                                          gap: "8px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <span
                                                          className="text-truncate d-inline-block mb-0"
                                                          style={{
                                                            maxWidth: "100%",
                                                            overflow: "hidden",
                                                            textOverflow:
                                                              "ellipsis",
                                                            whiteSpace:
                                                              "nowrap",
                                                            flex: 1,
                                                          }}
                                                          title={option?.value}
                                                        >
                                                          {ans?.answer_type ===
                                                          "file" && (
                                                          // <CopyLink
                                                          //   link={option?.value}
                                                          // />

                                                          <a
                                                            href={option?.value}
                                                            download
                                                            className="text-blue-500 cursor-pointer flex items-center gap-1"
                                                          >
                                                            <DownloadSimple
                                                              size={25}
                                                            />{" "}
                                                            Download File
                                                          </a>
                                                        )}
                                                          {ans?.answer_type !== "file" && option?.value}
                                                        </span>
                                                        
                                                      </p>
                                                    )
                                                  )}
                                                </div>
                                              ))}
                                          {showQuestions && <hr />}
                                        </div>
                                      </td>
                                    </tr>
                                  ) : null}
                                </>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </TableWrapper>
                  <div className="d-flex justify-content-between align-items-center">
                    <h2>Tasks</h2>
                    <p
                      className=" text-secondary small m-0  w-100 text-end me-3 cursor-pointer"
                      onClick={() => {
                        setShowCompletedTaskModal(true);
                      }}
                    >
                      <Eye /> See Completed Tasks
                    </p>
                    <button
                      className={` w-25
                          secondary-btn
                      `}
                      onClick={() => setShowTaskModal(true)}
                    >
                      <Plus /> Add Task
                    </button>
                  </div>
                  {memberInfo?.tasks
                    ?.filter((item) => item?.status === "open")
                    ?.reverse()
                    ?.map((task) => (
                      <div className="w-100 p-3 shadow-sm bg-white rounded-3 mt-2">
                        <div className="d-flex justify-content-between align-items-start">
                          {/* Left Section - Checkbox & Task Info */}
                          <div className="d-flex align-items-start">
                            <RadioButton
                              checked={task.isCompleted || false}
                              className="me-2 mt-1"
                              onChange={(value) => {
                                handleTaskStatus(task);
                              }}
                            />
                            <div>
                              <p className="heading-smb mb-1 text-muted  ">
                                {task.name}
                              </p>
                              <div className="d-flex align-items-center">
                                <FileText className="me-1" size={16} />
                                <span
                                  className="text-muted small"
                                  style={{
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {task.description}
                                </span>
                              </div>
                              <div className="d-flex align-items-center">
                                <User className="me-1" size={16} />
                                <span className="small">
                                  {task?.user?.name || "N/A"}
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* Right Section - Dates & Edit Button */}
                          <div
                            className="d-flex"
                            style={{
                              height: "76px",
                            }}
                          >
                            <div className="d-flex flex-column align-items-end justify-content-between ">
                              <p
                                className={`status ${
                                  task.status === "complete"
                                    ? "Enrolled"
                                    : task.status === "in_progress"
                                    ? "Excluded"
                                    : "pending"
                                } ps-1 pe-1`}
                              >
                                {moment(task.due_date, "DD/MM/YYYY").format(
                                  "MM/DD/YYYY"
                                )}
                              </p>

                              {/* <span className="badge bg-danger text-white px-2 py-1 mb-1">
                              {task.due_date}
                            </span> */}
                              <span className="text-muted small">
                                Created: {task.created_at}
                              </span>
                            </div>

                            {/* Edit Button */}
                            <button
                              className="border-0 bg-transparent p-1 ms-3"
                              onClick={() => {
                                setCurrentTaskEdit(task);
                                setShowTaskModal(true);
                              }}
                            >
                              <Pencil size={18} />
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
                <div className="col-12 col-md-5 survey-info">
                  {/* Assigned Outreach Staff */}
                  <p className=" d-flex gap-3 mb-0 mt-5 w-100 justify-content-end pe-5">
                    Assigned Outreach Staff:
                    <img
                      src={OutreachStafIcon}
                      className="my-img-svg "
                      width={26}
                      alt="icon"
                    />
                    {memberInfo.outreach_staff}
                    <Tooltip title="Edit">
                      <Pencil
                        size={24}
                        className=" ms-3  cursor-pointer"
                        onClick={() => {
                          setSelectedMember(originalMemberData);
                          handleOpenmemberModal();
                        }}
                      />
                    </Tooltip>
                  </p>
                  <div className="my-4 d-flex justify-content-between gap-3 ">
                    <button
                      className={` w-50 ${
                        activeTab === "memberInfo"
                          ? "primary-btn"
                          : "secondary-btn"
                      }`}
                      onClick={() => setActiveTab("memberInfo")}
                    >
                      Member Info
                    </button>
                    <button
                      className={` w-50 ${
                        activeTab === "referralInfo"
                          ? "primary-btn"
                          : "secondary-btn"
                      }`}
                      onClick={() => setActiveTab("referralInfo")}
                    >
                      Referral Info
                    </button>
                  </div>
                  <div className="my-4 d-flex justify-content-between gap-3 ">
                    <button
                      className={` col-12 ${
                        activeTab === "authorizations"
                          ? "primary-btn"
                          : "secondary-btn"
                      }`}
                      onClick={() => setActiveTab("authorizations")}
                    >
                      Authorizations
                    </button>
                  </div>

                  {activeTab === "memberInfo" ? (
                    <>
                      {/* Membership Info */}

                      <div className="w-100 p-4 border border-black border-opacity-10 border-1 bg-card-secondary rounded-3">
                        <h5 className="mt-3">Membership Info</h5>
                        <div className="mt-1 grid-container">
                          <div className="row">
                            <div className="col-sm-4">
                              <HeaderCard
                                title="CIN"
                                subTitle={memberInfo.cin}
                              />
                            </div>
                            <div className="col-sm-8">
                              <HeaderCard
                                title="FHIR ID"
                                subTitle={memberInfo.aica_account || "N/A"}
                              />
                            </div>
                            {/* <div className="col-sm-6">
                              <HeaderCard
                                title="Subscriber ID"
                                subTitle={memberInfo.subscriber_id || "N/A"}
                              />
                            </div> */}
                            <div className="col-sm-4">
                              <HeaderCard
                                title="Health Plan"
                                subTitle={memberInfo.health_plan || "N/A"}
                              />
                            </div>
                            <div className="col-sm-8">
                              <HeaderCard
                                title="IF Number"
                                subTitle={memberInfo?.if_number || "N/A"}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Personal Info */}
                      <div className="w-100 mt-3 p-4 border border-black border-opacity-10 border-1 bg-card-secondary rounded-3">
                        <h5 className="mt-3 ">Basic Info</h5>
                        <div className="mt-1 grid-container">
                          <div className="row">
                            <div className="col-sm-4">
                              <HeaderCard
                                title="Name"
                                subTitle={capitalizeName(memberInfo.memberName)}
                              />
                            </div>
                            <div className="col-sm-4">
                              <HeaderCard
                                title="Date of Birth"
                                subTitle={
                                  memberInfo.date_of_birth
                                    ? new Date(
                                        memberInfo.date_of_birth
                                      ).toLocaleDateString("en-US", {
                                        day: "numeric",
                                        month: "short",
                                        year: "numeric",
                                      })
                                    : "N/A"
                                }
                              />
                            </div>
                            <div className="col-sm-4">
                              <HeaderCard
                                title="Gender"
                                subTitle={
                                  capitalizeName(memberInfo?.gender) || "N/A"
                                }
                              />
                            </div>
                            <div className="col-sm-8">
                              <HeaderCard
                                title="Race/Ethnicity"
                                subTitle={
                                  formatString(memberInfo?.ehtnicity) || "N/A"
                                }
                              />
                            </div>
                            <div className="col-sm-4">
                              <HeaderCard
                                title="Marital Status"
                                subTitle={
                                  capitalizeName(memberInfo?.martial_status) ||
                                  "N/A"
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Contact Info */}
                      <div className="w-100 mt-3 p-4 border border-black border-opacity-10 border-1 bg-card-secondary rounded-3">
                        <h5 className="mt-3">Contact Info</h5>
                        <div className="mt-3 grid-container">
                          <div className="row align-items-start">
                            {/* First column: Phone and Home Address */}
                            <div className="col-sm-6">
                              <HeaderCard
                                title="Phone"
                                subTitle={memberInfo?.phone || "N/A"}
                              />
                              <div className="mt-3">
                                <HeaderCard
                                  title="Home Address"
                                  subTitle={
                                    memberInfo?.homeAddress
                                      ? addressSection(memberInfo.homeAddress)
                                      : "N/A"
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <HeaderCard
                                title="Email"
                                subTitle={memberInfo?.email || "N/A"}
                              />
                              <div className="mt-3">
                                <HeaderCard
                                  title="Mailing Address"
                                  subTitle={
                                    memberInfo?.mailingAddress
                                      ? addressSection(
                                          memberInfo.mailingAddress
                                        )
                                      : "N/A"
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Communication Preferences */}
                      <div className="w-100 mt-3 p-4 border border-black border-opacity-10 border-1 bg-card-secondary rounded-3">
                        <h5 className="mt-3 ">Communication Preferences</h5>
                        <div className="mt-1 d-flex justify-content-between  flex-wrap">
                          <HeaderCard
                            title="Preferred Language Spoken"
                            subTitle={
                              memberInfo?.preferred_spoken_lang || "N/A"
                            }
                          />
                          <HeaderCard
                            title="Preferred Language Written"
                            subTitle={
                              memberInfo?.preferred_written_lang || "N/A"
                            }
                          />
                        </div>
                      </div>
                      <div className="w-100 mt-3 p-4 border border-black border-opacity-10 border-1 bg-card-secondary rounded-3">
                        <h5 className="mt-3 ">Population of Focus</h5>
                        <div className="d-flex flex-row gap-3 flex-wrap  ">
                          {memberInfo.population_focuses &&
                          memberInfo.population_focuses.trim() !== "" ? (
                            formatString(memberInfo?.population_focuses)
                              .split(",")
                              .map((item, index) => (
                                <p
                                  key={index}
                                  className="badge px-3 py-2 rounded-5 text-black-50 bg-secondary-subtle border-black  border-opacity-10 border-1 "
                                >
                                  {item.trim()}
                                </p>
                              ))
                          ) : (
                            <p className="badge px-3 py-2 rounded-5 text-black-50 bg-secondary-subtle border-black  border-opacity-10 border-1 ">
                              N/A
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="w-100 mt-3 p-4 border border-black border-opacity-10 border-1 bg-card-secondary rounded-3">
                        <h5 className="mt-3 ">Conditions</h5>
                        <div className="d-flex flex-row gap-3 flex-wrap  ">
                          {memberInfo.conditions &&
                          memberInfo.conditions.trim() !== "" ? (
                            formatString(memberInfo?.conditions)
                              .split(",")
                              .map((item, index) => (
                                <p
                                  key={index}
                                  className="badge px-3 py-2 rounded-5 text-black text-black-50 bg-secondary-subtle border-black  border-opacity-10 border-1 "
                                >
                                  {item.trim()}
                                </p>
                              ))
                          ) : (
                            <p className="badge px-3 py-2 rounded-5  text-black-50 bg-secondary-subtle border-black  border-opacity-10 border-1 ">
                              N/A
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="mt-3 w-100 p-4 border border-black border-opacity-10 border-2 bg-card-secondary rounded-3">
                        <h5 className="fw-bold">Add Notes</h5>
                        <div className="mt-1 d-flex flex-column gap-3">
                          <Input
                            type="textarea"
                            value={comment?.content}
                            onChange={handleCommentChange}
                            onBlur={handleCommentUpdationOrCreation}
                          />
                        </div>
                      </div>
                    </>
                  ) : activeTab === "referralInfo" ? (
                    <div>
                      {originalMemberData?.addresses.some(
                        (a) =>
                          a.address_type === "mailing" &&
                          a.county_id == process.env.REACT_APP_COUNTY_ID
                      ) && (
                        <div className="mb-3 d-flex justify-content-between">
                          <h5 className="fw-bold">SPA Code</h5>
                          {originalMemberData?.spa_code ===
                          "Zip Code does not have assigned SPA Number" ? (
                            <p className="error-message-text">
                              {originalMemberData?.spa_code}
                            </p>
                          ) : (
                            <p>{originalMemberData?.spa_code}</p>
                          )}
                        </div>
                      )}
                      <h5 className="mt-3">Referral Info</h5>
                      {memberInfo.referrals.map((referral, index) => (
                        <div className="mt-1 grid-container w-100 p-4 border border-black border-opacity-10 border-1 bg-card-secondary rounded-3">
                          <div
                            key={index}
                            className="mt-1 d-flex flex-wrap gap-2"
                          >
                            <div className="col-sm-3">
                              <HeaderCard
                                title="Created Date"
                                subTitle={referral?.created_at || "N/A"}
                              />
                            </div>
                            <div className="col-sm-3">
                              <HeaderCard
                                title="Referral Program"
                                subTitle={
                                  formatString(referral?.referral_programe) ||
                                  "N/A"
                                }
                              />
                            </div>
                            <div className="col-sm-3">
                              <HeaderCard
                                title="Status"
                                subTitle={
                                  capitalizeName(referral?.referral_status) ||
                                  "N/A"
                                }
                              />
                            </div>
                            <div className="col-sm-3">
                              <HeaderCard
                                title="Created By"
                                subTitle={referral?.created_by || "N/A"}
                              />
                            </div>
                            <div className="col-sm-3">
                              <HeaderCard
                                title="Referral Source"
                                subTitle={referral?.referral_source || "N/A"}
                              />
                            </div>
                            <div className="col-sm-3">
                              <HeaderCard
                                title="Referral Provider"
                                subTitle={referral?.referring_provider || "N/A"}
                              />
                            </div>
                            {referral.approved_date && (
                              <div className="col-sm-3">
                                <HeaderCard
                                  title="Approved Date"
                                  subTitle={referral?.approved_date || "N/A"}
                                />
                              </div>
                            )}
                            <div className="col-sm-3">
                              <HeaderCard
                                title="IF Number"
                                subTitle={referral?.if_number || "N/A"}
                              />
                            </div>
                            <div className="col-sm-3">
                              <HeaderCard
                                title="Current Living Situation"
                                subTitle={
                                  formatString(
                                    referral?.current_living_situation
                                  ) || "N/A"
                                }
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : activeTab === "authorizations" ? (
                    <div>
                      <h5 className="mt-3">Authorization Info</h5>
                      {memberInfo.approved_referrals.map(
                        (approvedreferral, index) => (
                          <div className="mt-1 grid-container w-100 p-4 border border-black border-opacity-10 border-1 bg-card-secondary rounded-3">
                            <div
                              key={index}
                              className="mt-1 d-flex flex-wrap gap-2"
                            >
                              <div className="col-sm-3">
                                <HeaderCard
                                  title="Program"
                                  subTitle={
                                    approvedreferral?.referral_programe || "N/A"
                                  }
                                />
                              </div>
                              <div className="col-sm-3">
                                <HeaderCard
                                  title="Auth Number"
                                  subTitle={
                                    approvedreferral?.auth_number || "N/A"
                                  }
                                />
                              </div>
                              <div className="col-sm-3">
                                <HeaderCard
                                  title="Approved Days"
                                  subTitle={
                                    approvedreferral?.approved_days || "N/A"
                                  }
                                />
                              </div>
                              <div className="col-sm-4">
                                <HeaderCard
                                  title="Start Date"
                                  subTitle={
                                    formatString(
                                      approvedreferral?.start_date
                                    ) || "N/A"
                                  }
                                />
                              </div>
                              <div className="col-sm-3">
                                <HeaderCard
                                  title="End Date"
                                  subTitle={
                                    capitalizeName(
                                      approvedreferral?.end_date
                                    ) || "N/A"
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {showDeleteConfirm && (
        <CustomModal
          size="sm"
          show
          onHide={handleCloseDeleteModal}
          heading={`Confirmation`}
        >
          <div className="question-modal">
            <hr className="custom-modal-line mt-0 " />

            <form className="form-main" onSubmit={() => {}}>
              <h6>Are you sure you want to delete this survey?</h6>

              <hr className="custom-modal-line mt-4" />

              <div className="action gap-2">
                <button
                  className="secondary-btn w-50"
                  type="button"
                  onClick={handleCloseDeleteModal}
                >
                  Cancel
                </button>
                <button
                  className="primary-btn w-50"
                  type="button"
                  onClick={handleDeleteConfirm}
                >
                  Confirm
                </button>
              </div>
            </form>
          </div>
        </CustomModal>
      )}
      {showTaskModal && (
        <CustomModal
          className=" task-modal"
          size="sm"
          show
          onHide={handleCloseTaskModal}
          heading={`${Boolean(currentTaskEdit) ? "Edit" : "Add"} Task`}
        >
          <AddTaskForm
            handleSubmittion={handleTaskSubmission}
            handleClose={handleCloseTaskModal}
            currentTaskEdit={currentTaskEdit}
            users={activeUsers}
          />
        </CustomModal>
      )}
      {showCompletedTaskModal && (
        <CustomModal
          // className=" task-modal"
          size="sm"
          show
          onHide={handleCloseCompletedTaskModal}
          heading={
            memberInfo?.tasks?.filter((task) => task?.status === "complete")
              ?.length > 0
              ? `Completed Tasks`
              : "No Task Complete"
          }
        >
          {memberInfo?.tasks
            ?.filter((task) => task?.status === "complete")
            ?.map((task) => (
              <div className="w-100 p-3 shadow-sm bg-white rounded-3 mt-2">
                <div
                  className="d-flex justify-content-between align-items-start h-auto"
                  style={{ height: "76px" }}
                >
                  {/* Left Section - Checkbox & Task Info */}
                  <div className="d-flex align-items-start">
                    <RadioButton checked={task.isCompleted || true} />

                    <div>
                      <p className="heading-smb mb-1 text-muted  ">
                        {task.name}
                      </p>
                      <div className="d-flex align-items-center">
                        <FileText className="me-1" size={16} />
                        <span
                          className="text-muted small"
                          style={{
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                          }}
                        >
                          {task.description}
                        </span>
                      </div>
                      <div className="d-flex align-items-center">
                        <User className="me-1" size={16} />
                        <span className="small">
                          {task?.user?.name || "N/A"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Right Section - Dates & Edit Button */}
                  <div className="d-flex" style={{ height: "76px" }}>
                    <div className="d-flex flex-column align-items-end justify-content-between ">
                      <p
                        className={`status ${
                          task.status === "complete"
                            ? "Enrolled"
                            : task.status === "in_progress"
                            ? "Excluded"
                            : "pending"
                        } ps-1 pe-1`}
                      >
                        {moment(task.due_date, "DD/MM/YYYY").format(
                          "MM/DD/YYYY"
                        )}
                      </p>

                      {/* <span className="badge bg-danger text-white px-2 py-1 mb-1">
                      {task.due_date}
                    </span> */}
                      <span className="text-muted small">
                        Created: {task.created_at}
                      </span>
                    </div>

                    {/* Edit Button */}
                    <button className="border-0 bg-transparent p-1 ms-3">
                      <Pencil size={18} />
                    </button>
                  </div>
                </div>
              </div>
            ))}
        </CustomModal>
      )}
      {ismemberModalVisible && (
        <CustomModal
          size="sm"
          show
          onHide={handleClosememberModal}
          heading={`${selectedMember ? "Edit" : "Add"} Member`}
        >
          <Addmemberform
            handleQuestionSubmittion={handlememberSubmission}
            handleClose={handleClosememberModal}
            selectedMember={selectedMember}
          />
        </CustomModal>
      )}
      {isTemplateModalVisible && (
        <CustomModal
          size="sm"
          show
          onHide={handleCloseTemplateModal}
          heading={`Choose Template`}
        >
          <AsyncSelect
            label="Select Template"
            isRequired
            options={templatesList}
            loadOptions={(inputValue) =>
              new Promise((resolve) => {
                debouncedTemplateCallback(inputValue, resolve);
              })
            }
            selectedValue={selectedTemplate}
            placeholder="Select "
            handleChange={(option) => {
              setSelectedTemplate(option);
            }}
          />

          <div className="action gap-2">
            <button
              className="secondary-btn w-50"
              type="button"
              onClick={handleCloseTemplateModal}
            >
              Cancel
            </button>
            <button
              className="primary-btn w-50"
              type="button"
              disabled={!selectedTemplate}
              onClick={() => {
                navigate(`/survey/${memberInfo.memberID}`, {
                  state: {
                    ...memberInfo,
                    template_id: selectedTemplate?.value,
                  },
                });
              }}
            >
              Start Survey
            </button>
          </div>
        </CustomModal>
      )}
    </>
  );
};

export default SurveyHistory;
